import React from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";

import AppLayout from "./pages/Layout/AppLayout";

// Auth
import Login from "./pages/Auth/Login";
import Signup from "./pages/Auth/Signup";
import ResetPassword from "./pages/Auth/ResetPassword";

// Admin Portal
import UserManagement from "./pages/Admin Portal/UserManagement";
import ApplicationInvites from "./pages/Admin Portal/ApplicationInvites";

// Projects
import Projects from "./pages/Projects/Projects";
import ProjectEditor from "./pages/Projects/ProjectEditor";
import ProjectProperties from "./pages/Projects/ProjectProperties";
import ProjectContext from "./pages/Projects/ProjectContext";
import ProjectMembers from "./pages/Projects/ProjectMembers";
import ProjectInvites from "./pages/Projects/ProjectInvites";

// Hazards
import Hazards from "./pages/Hazards/Hazards";
import HazardEditor from "./pages/Hazards/HazardEditor";

import ProtectedRoute from "./components/ProtectedRoute";

import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <Router>
      <Toaster />

      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="reset-password" element={<ResetPassword />} />

        {/* Authentication protected routes */}
        <Route path="/" element={<AppLayout />}>
          {/* Projects */}
          <Route path="" element={<Navigate to="projects" replace />} />

          {/* Projects */}
          <Route path="projects">
            <Route
              path=""
              element={
                <ProtectedRoute>
                  <Projects />
                </ProtectedRoute>
              }
            />

            {/* Add project */}
            <Route
              path="add"
              element={
                <ProtectedRoute>
                  <ProjectEditor />
                </ProtectedRoute>
              }
            />

            {/* Edit project */}
            <Route
              path=":projectId/edit"
              element={
                <ProtectedRoute>
                  <ProjectEditor />
                </ProtectedRoute>
              }
            />

            {/* Project properties */}
            <Route
              path=":projectId/properties"
              element={
                <ProtectedRoute>
                  <ProjectProperties />
                </ProtectedRoute>
              }
            />

            {/* Project context */}
            <Route
              path=":projectId/context"
              element={
                <ProtectedRoute>
                  <ProjectContext />
                </ProtectedRoute>
              }
            />

            {/* Project access */}
            <Route path=":projectId/access">
              {/* Members */}
              <Route path="" element={<Navigate to="members" replace />} />

              <Route
                path="members"
                element={
                  <ProtectedRoute>
                    <ProjectMembers />
                  </ProtectedRoute>
                }
              />

              <Route
                path="invites"
                element={
                  <ProtectedRoute>
                    <ProjectInvites />
                  </ProtectedRoute>
                }
              />
            </Route>

            {/* Hazards */}
            <Route path=":projectId/hazards">
              <Route path="" element={<Navigate to="list" replace />} />

              {/* Hazards list */}
              <Route
                path="list"
                element={
                  <ProtectedRoute>
                    <Hazards />
                  </ProtectedRoute>
                }
              />

              {/* Add hazard */}
              <Route
                path="add"
                element={
                  <ProtectedRoute>
                    <HazardEditor />
                  </ProtectedRoute>
                }
              />

              {/* Edit hazard */}
              <Route
                path=":hazardId/edit"
                element={
                  <ProtectedRoute>
                    <HazardEditor />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Route>

          {/* Admin Portal */}
          <Route path="admin-portal">
            {/* User Management */}
            <Route path="" element={<Navigate to="users" replace />} />

            <Route
              path="users"
              element={
                <ProtectedRoute>
                  <UserManagement />
                </ProtectedRoute>
              }
            />

            {/* Application Invites */}
            <Route
              path="invites"
              element={
                <ProtectedRoute>
                  <ApplicationInvites />
                </ProtectedRoute>
              }
            />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
